import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingFloorAreaUnits = union([
    literal("square_meters"),
    literal("square_feet"),
]);
